import { FC } from 'react'
import { Row, Col, Text, Breadcrumb, Icon, Content } from '@/client/components'
import * as S from './styles'
import { InfosProps } from '../types'

export const Infos: FC<InfosProps> = ({ content: data }) => {
  const { breadcrumb, title, subtitle, pdf_link, pdf_title, content } = data
  return (
    <S.Featured>
      <Row>
        <Col>
          <Breadcrumb pages={breadcrumb} />
        </Col>
      </Row>
      <Row>
        <Col>
          <S.MainFeatured>
            <Text as='h2' color='primary' family='heading'>
              {subtitle}
            </Text>
            <Text as='h1' size='xxlg' family='heading' weight='bold' margin='0 0 2.5rem' itemProp='name'>
              {title}
            </Text>
          </S.MainFeatured>

          {pdf_link && pdf_title && (
            <S.PdfBox href={pdf_link} target='_blank'>
              <S.IconWrapper>
                <Icon id={title} name='pdf' size='s6' color='#008FBE' />
              </S.IconWrapper>
              <Text size='sm' weight='bold' margin='0'>
                {pdf_title}
              </Text>
            </S.PdfBox>
          )}

          {content && <Content content={content} />}
        </Col>
      </Row>
    </S.Featured>
  )
}
